import {
  PRODUCT_TYPE_MODELS,
  SHARE_CLASS
} from '../../shared/screener-constants';

//fundTypeValue = fund type value , productTypeValue = product type value
//variable annuities doesn't have a direct fund type value it applies the 3 sub fund types and the sub fund types don't have product types
//some funds only have product type values and only work with screener 329

const productType = () => {
  return {
    [PRODUCT_TYPE_MODELS.FIXEDANNUITIES]: {
      key: 'fixed-annuities',
      label: 'Fixed Annuities',
      productTypeValue: 'Fixed Annuities',
      fundTypeValue: 'TIAA Fixed Annuity',
      modelKey: PRODUCT_TYPE_MODELS.FIXEDANNUITIES,
      checked: true
    },
    [PRODUCT_TYPE_MODELS.VARIABLEANNUITIES]: {
      key: 'variable-annuities',
      label: 'Variable Annuities',
      productTypeValue: 'Variable Annuities',
      modelKey: PRODUCT_TYPE_MODELS.VARIABLEANNUITIES,
      checked: true
    },
    [PRODUCT_TYPE_MODELS.CREF]: {
      key: 'cref',
      label: 'CREF',
      fundTypeValue: 'CREF Variable Annuity',
      modelKey: PRODUCT_TYPE_MODELS.CREF,
      checked: true,
      currentOption: SHARE_CLASS.CLASSR3,
      options: [
        SHARE_CLASS.ALL,
        SHARE_CLASS.CLASSR4,
        SHARE_CLASS.CLASSR3,
        SHARE_CLASS.CLASSR2,
        SHARE_CLASS.CLASSR1
      ]
    },
    [PRODUCT_TYPE_MODELS.TIAAACCESS]: {
      key: 'tiaa-access',
      label: 'TIAA Access',
      fundTypeValue: 'TIAA Access Variable Annuity',
      modelKey: PRODUCT_TYPE_MODELS.TIAAACCESS,
      checked: true,
      currentOption: SHARE_CLASS.LEVEL1,
      options: [
        SHARE_CLASS.ALL,
        SHARE_CLASS.LEVEL1,
        SHARE_CLASS.LEVEL2,
        SHARE_CLASS.LEVEL3,
        SHARE_CLASS.LEVEL4
      ]
    },
    [PRODUCT_TYPE_MODELS.TIAAREALESTATE]: {
      key: 'tiaa-real-estate',
      label: 'TIAA Real Estate',
      fundTypeValue: 'TIAA Variable Annuity', //not sure about this
      modelKey: PRODUCT_TYPE_MODELS.TIAAREALESTATE,
      checked: true
    },
    [PRODUCT_TYPE_MODELS.MUTUALFUNDS]: {
      key: 'mutual-funds',
      label: 'Mutual Funds',
      productTypeValue: 'Mutual Funds',
      fundTypeValue: 'Mutual Fund',
      modelKey: PRODUCT_TYPE_MODELS.MUTUALFUNDS,
      checked: true,
      currentOption: SHARE_CLASS.CLASSR6,
      options: [
        SHARE_CLASS.ALL,
        SHARE_CLASS.CLASSR6,
        SHARE_CLASS.PREMIER,
        SHARE_CLASS.RETIREMENT,
        SHARE_CLASS.CLASSA,
        SHARE_CLASS.CLASSI,
        SHARE_CLASS.CLASSW
      ]
    },
    [PRODUCT_TYPE_MODELS.RETIREPLUSMODELS]: {
      key: 'retire-plus',
      label: 'RetirePlus Select',
      productTypeValue: 'RetirePlus Models',
      modelKey: PRODUCT_TYPE_MODELS.RETIREPLUSMODELS,
      checked: false
    },
    [PRODUCT_TYPE_MODELS.RETIREPROPLUSMODELS]: {
      key: 'retire-plus-pro',
      label: 'RetirePlus Pro  Models',
      productTypeValue: 'Custom Portfolio Models',
      modelKey: PRODUCT_TYPE_MODELS.RETIREPROPLUSMODELS,
      checked: false
    },
    [PRODUCT_TYPE_MODELS.FDICINSUREDPRODUCTS]: {
      key: 'fdic',
      label: 'FDIC Insured Products',
      productTypeValue: 'FDIC Insured Products',
      fundTypeValue: 'FDIC Insured Bank Product',
      modelKey: PRODUCT_TYPE_MODELS.FDICINSUREDPRODUCTS,
      checked: false
    },
    [PRODUCT_TYPE_MODELS.OTHER]: {
      key: 'product-other',
      label: 'CITs & Other',
      productTypeValue: 'Other Investments',
      fundTypeValue: 'Other Investment',
      modelKey: PRODUCT_TYPE_MODELS.OTHER,
      checked: false
    }
  };
};

export default productType;
